namespace Portico.Services {
    import models = Portico.Models.Pdf;
    import Inject = Portico.Decorators.Inject;
    import interfaces = Portico.Models.Interfaces;
    import Service = Portico.Decorators.Service;

    export interface IPdfService {
        createDocumentServicePdf(request: models.AddDocumentRequestModel): angular.IPromise<any>;
        createDocumentServicePdfFromSimpleDictionary(programId: number, key: string, contentDictionary: {}): angular.IPromise<any>;
        createHTMLDocumentServicePdf(request: models.AddDocumentRequestModel): angular.IPromise<any>;
    }

    @Service('app', 'pdfService')
    @Inject('$q', 'apiService', 'dataService', 'serverConstants', 'storageService')
    export class PdfService implements IPdfService {
        constructor(
            private $q: angular.IQService,
            private apiService: IApiService,
            private dataService: IDataService,
            public serverConstants: interfaces.IServerConstants,
            private storageService: IStorageService
        ) { }

        createDocumentServicePdf(request: models.AddDocumentRequestModel): angular.IPromise<any> {
            const endpoint = `/pdfdocument`;

            return this.apiService.searchItem<models.AddDocumentRequestModel, any>(endpoint, request);
        }

        createDocumentServicePdfFromSimpleDictionary(programId: number, key: string, contentDictionary: {}): angular.IPromise<any> {
            const endpoint = `/pdfdocument`;

            const template = this.dataService.getDataValue('PDF', 'Template', key).replace('{{$app.serverConstants.contentPath}}', this.serverConstants.contentPath);
            const fileName = this.dataService.getDataValue('PDF', 'Filename', key);
            let pdfContents = JSON.parse(this.dataService.getDataValue('PDF', 'Contents', key));

            pdfContents = pdfContents.map(pdfContent => {
                pdfContent.content = contentDictionary[pdfContent.content];
                return pdfContent;
            });

            var request: models.AddDocumentRequestModel = {
                programId,
                pdfRequest: {
                    fileName,
                    template,
                    pdfContents
                }
            };

            return this.apiService.searchItem<models.AddDocumentRequestModel, any>(endpoint, request);
        }
        createHTMLDocumentServicePdf(request: models.AddDocumentRequestModel): angular.IPromise<any> {
            const endpoint = `/pdfdocumenthtml`;

            return this.apiService.searchItem<models.AddDocumentRequestModel, any>(endpoint, request);
        }
    }
}